<template>
  <div>
    <vm-table ref="vmTable" url="periodicInspectionBill" :filter.sync="search">
      <template slot="adSearch">
        <vm-search :label="$l('dwmManger.filter', '关键字检索')">
          <el-input v-model.trim="search.filter" :placeholder="$t('common.search')" clearable></el-input>
        </vm-search>
        <vm-search :label="$l('dwmManger.status', '状态')">
          <el-select v-model="search.status" clearable>
            <el-option :value="1" :label="$l('dwmManger.submit', '已提交')"></el-option>
            <el-option :value="0" :label="$l('dwmManger.noSubmit', '未提交')"></el-option>
          </el-select>
        </vm-search>
        <vm-search label="是否异常">
          <el-select v-model="search.exceptional" clearable>
            <el-option :value="true" label="异常"></el-option>
            <el-option :value="false" label="未见异常"></el-option>
          </el-select>
        </vm-search>
      </template>
      <template slot="toolbar">
        <el-button class="addBtn" @click="$refs.monthDispatchEdit.open()">
          {{ $l("common.add", "+ 新增") }}
        </el-button>
        <div style="position: absolute;right: 32px;top: 0;color: #4d4d4d;font-size: 12px;">
          <span>开通台数：</span>
          <span style="font-family: 'electronicFont';color: #0747fd;font-size: 40px;">{{count}}</span>
          <span>台</span>
        </div>
      </template>
      <el-table-column prop="billNo" :label="$l('dwmManger.no', '编号')" width="120" align="center">
        <template slot-scope="scope">
          <router-link :to="'/monthDispatch/' + scope.row.id" target="_blank">{{ scope.row.billNo }}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="elevatorNO" :label="$l('dwmManger.elevatorNo', '电梯编号')" width="120" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="elevatorName" :label="$l('dwmManger.elevatorName', '电梯名称')"
        show-overflow-tooltip></el-table-column>
      <el-table-column prop="useUnitName" :label="$t('elevator.useUnit')" show-overflow-tooltip></el-table-column>
      <el-table-column prop="status" :label="$l('dwmManger.status', '状态')" width="60" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">{{ $l("dwmManger.noSubmit", "未提交") }}</span>
          <span v-else-if="scope.row.status === 1">{{ $l("dwmManger.submit", "已提交") }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="exceptionCount" :label="$l('dwmManger.status', '调度结果')" width="100" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="!scope.row.exceptionCount">未见异常</el-tag>
          <el-tag type="danger" v-else>{{ scope.row.exceptionCount }} 项异常</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="调度周期" align="center" width="180">
        <tempalte slot-scope="scope">
          <span>{{ scope.row.startDate + ' 至 ' + scope.row.endDate }}</span>
        </tempalte>
      </el-table-column>
      <el-table-column prop="createTime" :label="($l('dwmManger.createTime'), '创建时间')" width="140"
        align="center"></el-table-column>
      <el-table-column prop="creator" :label="($l('dwmManger.creator'), '创建人')" width="100" align="center"
        show-overflow-tooltip></el-table-column>
      <el-table-column :label="($l('common.operation'), '操作')" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text">
            <router-link :to="'/EchartReport/' + scope.row.id + '/2'" target="_blank">查看</router-link>
          </el-button>
          <el-button type="text" @click="$refs.monthDispatchEdit.open(scope.row.id)">{{ $l("common.edit", "编辑")
          }}</el-button>
          <el-button class="operateDelBtn" type="text" @click="handleDelete(scope.row)">{{ $l("common.delete", "删除")
          }}</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <month-dispatch-edit ref="monthDispatchEdit" @save-success="getList(1)"></month-dispatch-edit>
  </div>
</template>

<script>
import monthDispatchEdit from "./monthDispatchEdit.vue";
export default {
  components: { monthDispatchEdit },
  data() {
    return {
      search: {
        filter: "",
        status: "",
        periodicType: 30,
        exceptional: ""
      },
      count: 0
    };
  },

  mounted() {
    this.getList(1);
    this.getNumber();
  },

  methods: {
    getList(pageNum) {
      this.$refs.vmTable.getList(pageNum);
    },

    getNumber() {
      this.$http.get("periodicInspectionBill/count/auto").then(res => {
        this.count = res.data;
      });
    },

    // 删除
    handleDelete(row) {
      this.$confirm(this.$l("dwmManger.tip.confirmDelete", "确认删除吗？"), this.$t("common.tips"), {
        confirmButtonText: this.$l("common.confirm", "确定"),
        cancelButtonText: this.$l("common.cancel", "取消"),
        type: "warning",
      }).then(() => {
        this.$http
          .delete("periodicInspectionBill", row.id)
          .then(() => {
            this.getList(-1);
            this.$message.success(this.$l("common.tip.deleteSuccess"));
          })
          .catch(() => {
            this.$message.error(this.$l("common.tip.deleteError"));
          });
      });
    },
  },
};
</script>
